import React from 'react';
import WMICHOCustomCoverageTermDetailView from '../../WMICHOCustomCoverageTerm/WMICHOCustomCoverageTermDetailView/WMICHOCustomCoverageTermDetailView';
import metadata from './WMICHOBusinessPropertyCovDetailView.metadata.json5';

function WMICHOBusinessPropertyCovDetailView(props) {
    const { id, itemVM, onSaveItem, onCancelItem, onValidate: parentOnValidate, showErrors: parentShowErrors } = props;

    return (
        <WMICHOCustomCoverageTermDetailView
            id={id}
            itemVM={itemVM}
            onSaveItem={onSaveItem}
            onCancelItem={onCancelItem}
            onValidate={parentOnValidate}
            showErrors={parentShowErrors}
            content={metadata.componentContent}
        />
    );
}

export default WMICHOBusinessPropertyCovDetailView;
